var module = angular.module('octopusApp.infrastructure');

// A service that helps to show a spinner/busy indicator when a background action is happening, using promises.
// When the busy service is injected into your controller, you can create a busy state:
//
//   var isLoading = scope.isLoading = busy.create();
//
// You can then use it to track promises:
//
//   isLoading.promise(somePromise);
//
// For example, a REST API request:
//
//   isLoading.promise(octopusRepository.Users.getCurrent().then(function (user) {
//     console.log('Got a user', user);
//   }));
//
// It exposes a property which you can use to show/hide a busy indicator when the promises are active:
//
//   <spin active='isLoading.busy'></spin>
//
// You can also show any errors which are returned from the promise:
//
//   <error-box error='isLoading.error'></error-box>
//
module.factory('busy', function ($rootScope, $q) {

  var BusyState = function () {
    var promises = [];
    var self = this;
    self.error = null;
    self.busy = false;

    self.showError = function(message) {
      self.error = { ErrorMessage: message };
    };

    self.clearError = function(){
      self.error = null;
    };

    self.showErrors = function(message, errors) {
      self.error = { ErrorMessage: message, Errors: errors };
    };

    self.refresh = function () {
      self.busy = promises.length > 0;
      if (!($rootScope.$$phase)) {
        $rootScope.$digest();
      }
    };

    self.promises = function (proms) {
      return self.promise($q.all(proms));
    };

    self.promise = function (prom) {
      promises.push(prom);
      self.refresh();

      var onComplete = function () {
        var ix = promises.indexOf(prom);
        if (ix >= 0) {
          promises.splice(ix, 1);
        }

        self.refresh();
      };

      var def = $q.defer();
      prom.then(function (r) {
        self.error = null;
        onComplete();
        def.resolve(r);
      }, function (err) {
        self.error = err;
        onComplete();
        def.reject(err);
      });

      return def.promise;
    };

    return self;
  };

  return {
    create: function () {
      return new BusyState();
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/busy.js
// module id = 8985495723146260
// module chunks = 1